const prefix = '/v2/customer';
export const customer = {
    searchTeacher: prefix + '/teachers',
    invoicePreviousOrNext: prefix + '/invoicePreviousOrNext',
    fetchPaymentDate: prefix + '/fetchPaymentDate',
    fetchPaymentDateForToday: prefix + '/fetchPaymentDateForToday',
    generateInvoicePDF: prefix + '/generateInvoicePDF',
    fetchApproverForInvoices: prefix + '/fetchApproverForInvoices',
}